import useModal from '@fipnooone/react-modal';
import { useCallback } from 'react';

import { Api, Code } from '@.api';
import { Responses } from '@.api/methods';
import { ModalConfirm } from '@.modal';

interface UseDeleteBrandParameters {
    onSuccessDelete?: () => void;
    onError?: (response: Responses<unknown>) => void;
}

export const useDeleteBrand = (parameters: UseDeleteBrandParameters = {}) => {
    const [modal, modalControls] = useModal();

    const deleteBrand = useCallback(
        (brandId?: number) => {
            if (!brandId) {
                throw new Error('Brand id is required.');
            }

            const remove = async () => {
                const response = await Api.brands().delete(brandId);

                if (response.code !== Code.Success) {
                    if (parameters.onError) {
                        parameters.onError(response);
                    } else {
                        alert(response.message);
                    }

                    return;
                }

                if (parameters.onSuccessDelete) {
                    parameters?.onSuccessDelete();
                } else {
                    modalControls.close();
                }
            };

            modalControls.set(
                <ModalConfirm message="Are you sure you want to FULL delete the brand?" onConfirm={remove} onCancel={() => modalControls.close()} />
            );
        },
        [modalControls, parameters]
    );

    return { deleteBrand, modal };
};
